// Intelligems test harness. Each test reads its group from
// window.igData?.user.getTestGroup("<UUID>") and adds a "c-<slug>-<variant>" body class;
// CSS and Liquid branch off that class. Test UUIDs are scoped to the Dr. Herma
// Intelligems account, so IDs from other stores resolve to undefined (= control).
//
// The Intelligems runtime is loaded by the app embed enabled in config/settings_data.json,
// not by the commented-out tag in layout/theme.liquid.

let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
